/**
 * Category filter options. With a type picked, categories under that type are listed and filtered by id.
 * Without one, every category is listed once by name ("saree" exists under several types), and the
 * filter matches products by category name across all types.
 */
export type CategoryOption = { label: string; value: string; byName?: boolean };

/** How many categories to load when no type is picked (all of them in practice). */
export const ALL_CATEGORIES_LIMIT = 200;

export function toCategoryOptions(docs: any[] | undefined, byName: boolean): CategoryOption[] {
  const rows = (docs || []).filter((row) => row && typeof row.name === "string" && row.name.trim());
  if (!byName) {
    return rows.map((row) => ({ label: row.name, value: row._id }));
  }
  const seen = new Map<string, CategoryOption>();
  rows.forEach((row) => {
    const name = row.name.trim();
    const key = name.toLowerCase();
    if (!seen.has(key)) seen.set(key, { label: name, value: name, byName: true });
  });
  return Array.from(seen.values()).sort((a, b) => a.label.localeCompare(b.label));
}

/** Query params for the products API: an id-based pick sends categoryId, a name-based pick sends categoryName. */
export function categoryParams(category: CategoryOption | undefined | null): { categoryId?: string; categoryName?: string } {
  if (!category || !category.value) return {};
  return category.byName ? { categoryName: category.value } : { categoryId: category.value };
}
